export default __webpack_public_path__ + "static/media/Gauntlets of the Tormentor.d65d56e7.jpg";